import React from 'react';
import constClass from '../../Constants/Constants';
import moment from 'moment';

const rowClass = "card-header p-2 text-left border";

//開催中キャンペーンの加算ポイント見込みを算出（バックエンド Points.calc と同じ計算）
//isFixed: 100%当選（確定時に必ず加算）、patterns: 倍率ごとの加算ポイント
const getCampaignPointPreview = (campaignList, paymentMethod, basePoint, maxPoint) => {
  if (!campaignList || !(basePoint > 0)) return [];
  return campaignList
    .filter(x => (!Object.values(constClass.PAYMENT_METHOD).includes(x.payment_method.toString()) ||
      !paymentMethod ||
      x.payment_method.toString() === paymentMethod.toString())
    )
    .map(item => {
      const subs = item.m_point_campaign_sub || [];
      const isFixed = subs.length === 1 && Number(subs[0].percent) === 100;
      const patterns = subs.map(sub => {
        const magnification = Number(sub.magnification);
        const permaxpoint = item.point_limit ? Number(item.point_limit) : Number(maxPoint || 0) * magnification;
        var point = (magnification === 0) ? 0 : Math.floor(basePoint * magnification) - basePoint;
        if (permaxpoint > 0 && basePoint + point > permaxpoint) point = permaxpoint - basePoint;//ポイント付与上限まで
        return { magnification, percent: Number(sub.percent), point };
      }).filter(p => p.point > 0);
      return { point_campaign_name: item.point_campaign_name, isFixed, patterns };
    })
    .filter(c => c.patterns.length > 0);
}

// ポイント付与の確認・完了画面で、付与ポイントの合計と内訳（通常ポイント／キャンペーン加算）を表示する
const PointBreakdown = ({ appState }) => {
  // 完了画面：抽選に当選したキャンペーンのみ内訳に表示
  if (appState.pointRegist) {
    const campaignList = appState.pointCampaignList || [];
    const campaignPoint = campaignList.reduce((sum, item) => sum + (item.point || 0), 0);
    return (
      <React.Fragment>
        <div className={rowClass}>
          <span><b>加算ポイント（合計）:</b></span>
          <span className="float-right pr-2"><b>{appState.addPoint.toLocaleString()}</b> ポイント</span>
        </div>
        {campaignList.length > 0 &&
          <React.Fragment>
            <div className={rowClass}>
              <span className='two-column-row'>
                <span className='left-column'><b>通常ポイント:</b></span>
                <span className="right-column"><b>{(appState.addPoint - campaignPoint).toLocaleString()}</b> ポイント</span>
              </span>
            </div>
            {campaignList.map((item, idx) => (
              <div className={rowClass} key={idx}>
                <div className="two-column-row">
                  <span className="left-column">
                    <b>{item.point_campaign_name}:</b>
                  </span>

                  <span className="right-column">
                    <b>{item.point.toLocaleString()}</b> ポイント
                  </span>
                </div>
              </div>
            ))}
          </React.Fragment>
        }
        {appState.ticketList && appState.ticketList.length > 0 &&
          <React.Fragment>
            <div className={rowClass}>
              <span><b>付与クーポン:</b></span>
            </div>
            {appState.ticketList.map((item, idx) =>
              <div className="card-header p-2 text-left border" key={idx}>
                <span className='two-column-row'>
                  <span className='left-column'><b>{item.ticket_name}:</b></span>
                  <span className="right-column">有効期限:<b>{moment(item.ticket_end_date).format('YYYY/MM/DD')}</b></span>
                </span>
              </div>
            )}
          </React.Fragment>
        }
      </React.Fragment>
    );
  }

  // 確認画面：100%当選は合計に含め、抽選キャンペーンは「当選時」として別表示
  const campaigns = getCampaignPointPreview(appState.pointCampaignList, appState.paymentMethod, appState.addPoint, appState.max_point);
  const fixedCampaigns = campaigns.filter(c => c.isFixed);
  const lotteryCampaigns = campaigns.filter(c => !c.isFixed);
  const fixedPoint = fixedCampaigns.reduce((sum, c) => sum + c.patterns[0].point, 0);
  return (
    <React.Fragment>
      <div className={rowClass}>
        <span><b>付与予定ポイント（合計）:</b></span>
        <span className="float-right pr-2"><b>{(appState.addPoint + fixedPoint).toLocaleString()}</b> ポイント</span>
      </div>
      {campaigns.length > 0 &&
        <React.Fragment>
          <div className={rowClass}>
            <span className='two-column-row'>
              <span className='left-column'><b>通常ポイント:</b></span>
              <span className="right-column"><b>{appState.addPoint.toLocaleString()}</b> ポイント</span>
            </span>
          </div>
          {fixedCampaigns.map((c, idx) => (
            <div className={rowClass} key={`fixed-${idx}`}>
              <div className="two-column-row">
                <span className="left-column">
                  <b>{c.point_campaign_name}:</b>
                </span>

                <span className="right-column">
                  <b>{c.patterns[0].point.toLocaleString()}</b> ポイント
                </span>
              </div>
            </div>
          ))}
          {lotteryCampaigns.map((c, idx) =>
            c.patterns.map((p, pIdx) => (
              <div className={`${rowClass} text-muted`} key={`lottery-${idx}-${pIdx}`}>
                <span className="two-column-row">
                  <span className="left-column"><b>{c.point_campaign_name}（抽選{p.percent}%・{p.magnification}倍）:</b></span>
                  <span className="right-column">当選時 <b>{p.point.toLocaleString()}</b> ポイント</span>
                </span>
              </div>
            ))
          )}
        </React.Fragment>
      }
      {appState.ticketList && appState.ticketList.length > 0 &&
        <React.Fragment>
          <div className="card-header p-2 text-left border"><span><b>付与予定クーポン:</b></span></div>
          {appState.ticketList.map((item, idx) =>
            <div className="card-header p-2 text-left border" key={idx}>
              <span className='two-column-row'>
                <span className='left-column'><b>{item.ticket_name}:</b></span>
                <span className="right-column">有効期限:<b>{moment(item.ticket_end_date).format('YYYY/MM/DD')}</b></span>
              </span>
            </div>
          )}
        </React.Fragment>
      }
      {lotteryCampaigns.length > 0 &&
        <div className="p-2 text-left small text-danger">
          ※対象キャンペーンのポイントは、付与確定時の抽選で当選した場合のみ加算されます（付与予定ポイント（合計）には含まれません）。
        </div>
      }

    </React.Fragment>
  );
}

export default PointBreakdown;
